// import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
// import { useNavigate } from 'react-router-dom'

import styles from './styles.module.scss'

export const Content = () => {
  const { t } = useTranslation(['buttons', 'errorContentPage'])

  // const navigate = useNavigate()

  // const redirectToMain = useCallback(() => {
  //   navigate('/')
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  // ? TODO add debug info like all redux state, cookies, etc ?
  // ? Reload page button instead of "Go to the main..."

  return (
    <div className={styles['page-error-block']}>
      <h1 className={styles.error}>{t('errorContentPage:errorTitle')}</h1>
      <h1>{t('errorContentPage:genErrorTitle')}</h1>
      <p>{t('errorContentPage:pleaseContact')}</p>
      {/* <p>
        <Btn
          styles={['uppercase', 'fwidth_auto']}
          variant="filled"
          onClick={redirectToMain}
        >
          {t('buttons:goToMain')}
        </Btn>
      </p> */}
    </div>
  )
}
